import logoHeader from "./images/logo-header.png";
import Thai from "./images/thai.png";
import Eng from "./images/eng.png";
import logoGreen from "./images/logo-green.svg";
import Mascotte from "./images/mascotte.png";
import LoginImg from "./images/login-img.png";
import LogoPila from "./images/logo-pila.png";
export { logoHeader, Thai, Eng, logoGreen, Mascotte, LoginImg, LogoPila };

import FindTheMatch from "./images/games/findthematch.png";
import GameshowQuiz from "./images/games/gameshowquiz.png";
import FlipCards from "./images/games/flipcards.png";
import AirPlanFlyingFruits from "./images/games/airplanflyingfruits.png";
import FlappyBird from "./images/games/flappybird.png";
import WhackAMole from "./images/games/whackamole.png";
import Anagram from "./images/games/anagram.png";
import CompleteTheSentence from "./images/games/completethesentence.png";
import Situation from "./images/games/situation.png";
import Sequence from "./images/games/sequence.png";
export {  FindTheMatch, GameshowQuiz, FlipCards, AirPlanFlyingFruits, FlappyBird, WhackAMole, Anagram, CompleteTheSentence, Situation, Sequence };

import SmFindTheMatch from "./images/games/small/findthematch.png";
import SmGameshowQuiz from "./images/games/small/gameshowquiz.png";
import SmFlipCards from "./images/games/small/flipcards.png";
import SmAirPlanFlyingFruits from "./images/games/small/airplanflyingfruits.png";
import SmFlappyBird from "./images/games/small/flappybird.png";
import SmWhackAMole from "./images/games/small/whackamole.png";
import SmAnagram from "./images/games/small/anagram.png";
import SmCompleteTheSentence from "./images/games/small/completethesentence.png";
export { SmFindTheMatch, SmGameshowQuiz, SmFlipCards, SmAirPlanFlyingFruits, SmFlappyBird, SmWhackAMole, SmAnagram, SmCompleteTheSentence };